import {
    Button as AntButton,
    Col,
    Drawer,
    Form,
    Image,
    Modal,
    Popconfirm,
    Row,
    Switch,
    Table,
    Tooltip,
    notification
} from 'antd';
import {ColumnsType} from 'antd/es/table';
import React, {useEffect, useState} from 'react';
import {Button, OverlayTrigger, Popover} from "react-bootstrap";
import {Icon} from 'ts-react-feather-icons';
import {UserRole} from '../../constants/userRole';
import {useUser} from '../../hooks';
import User from '../../model/User';
import CustomPagination from '../CustomPagination';
import {
    createCharacterImageGenProfiles,
    deleteCharacterImageGenProfile,
    getCharacterImageGenProfiles,
    updateCharacterImageGenProfile
} from "../../helpers/api/character";
import {EyeOutlined} from "@ant-design/icons";

interface CharacterImageGenProfileModel {
    key: React.Key;
    id: string;
    url: string;
    status: string;
    createdAt: Date;
    modifiedAt: Date;
    createdBy: string;
    modifiedBy: string;
    seedId: string;
    prompt: string;
    characterId: string;
    appearance: string;
}

const CharacterImageGenProfileDrawer = ({
                                            storyId,
                                            drawerVisibility,
                                            setdDrawerVisibility,
                                            characterDetail,
                                        }: any) => {
    const currentLoggedInUser = useUser().user as User || null;

    const [form] = Form.useForm();


    const [loadingBtn, setLoadingBtn] = useState<boolean>(false);
    const [pageSize, setPageSize] = useState<number>(10);
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [totalRecord, setTotalRecord] = useState<number>(0);
    const [characterImageGenProfiles, setCharacterImageGenProfiles] = useState<any[]>([]);
    const [searchLoading, setSearchLoading] = useState<boolean>(false);

    const [api, contextHolder] = notification.useNotification();
    const showError = (errorMessage: string) => {
        api.error({
            message: `Error notification`,
            description: <span className="text-danger">{errorMessage || 'There\'re some errors occured!'}</span>,
            placement: 'topRight'
        });
    }


    useEffect(() => {
        if (!characterDetail) {
            form.setFieldValue("status", "inactive");
            return;
        }
        form.setFieldsValue({...characterDetail});
        search();
    }, [characterDetail]);


    const aiGen = async () => {
        try {
            setLoadingBtn(true);
            let response;
            response = await createCharacterImageGenProfiles(characterDetail.id, {});

            setLoadingBtn(false);
            if (response?.status === 200) {
                api.success({
                    message: `Successfull notification`,
                    description: 'Gen image and appearance successfully!',
                    placement: 'topRight'
                });
                search();
                return;
            }
        } catch (err) {
            console.log(err);
            showError(err as string);
        }
        setLoadingBtn(false);
    }


    const columns: ColumnsType<CharacterImageGenProfileModel> = [
        {
            title: "No.",
            dataIndex: "noNumber"
        },
        {
            title: "Image",
            dataIndex: "name",
            render: (text, record, index) => {
                return (
                    <span>
                            <Image
                                width={50}
                                src={record.url}
                            />
                    </span>
                )
            },
        },
        {
            title: "Appearance",
            dataIndex: "appearance",
            render: (text, record) => {
                let jsonObj = JSON.parse(record.appearance);

                const short = JSON.stringify(jsonObj, null, 0).slice(0, 20) + "...";

                return (
                    <OverlayTrigger
                        placement="left"
                        trigger="click"
                        rootClose
                        overlay={
                            <Popover id="popover-basic">
                                <Popover.Header as="h3">Detail</Popover.Header>
                                <Popover.Body>
                                    <div style={{maxHeight: 400, maxWidth: 500, overflow: "auto"}}>
                                        <pre style={{whiteSpace: "pre-wrap", margin: 0}}>
                                            {JSON.stringify(jsonObj, null, 2)}
                                        </pre>
                                    </div>
                                </Popover.Body>
                            </Popover>
                        }
                    >
                        <AntButton type="link" icon={<EyeOutlined rev={undefined}/>}>
                            {short}
                        </AntButton>
                    </OverlayTrigger>
                );
            }
        },
        {
            title: "Seed ID",
            dataIndex: "seedId",
        },
        {
            title: "Created at",
            dataIndex: "createdAt",
            render: (text, record, index) => {
                return <span>{record?.createdAt ? new Date(record?.createdAt).toLocaleString() : ''}</span>
            }
        },
        {
            title: "Published?",
            dataIndex: "activated",
            render: (text, record, index) => {
                return (
                    <Popconfirm
                        title={`${record.status === "active" ? "Hide" : "Show"} character image`}
                        description={`Are you sure to ${record.status === "active" ? "hide" : "show"} this character image?`}
                        onConfirm={() => changeImageVisibility(record, record.status)}
                        okText="OK"
                        cancelText="Cancel"
                    >
                        <Switch checked={record.status === 'active'}
                                disabled={
                                    (!currentLoggedInUser?.roles?.includes(UserRole.SUPER_ADMIN)
                                        && !currentLoggedInUser?.roles?.includes(UserRole.ADMIN))
                                }
                        />
                    </Popconfirm>
                )
            },
        },
        {
            title: "Action",
            dataIndex: "action",
            render: (text, record, index) => {
                return (
                    <>
                        {
                            (currentLoggedInUser?.roles?.includes(UserRole.SUPER_ADMIN) || currentLoggedInUser?.roles?.includes(UserRole.ADMIN)) &&
                            record.status !== "active" && (
                                <>
                                    <Popconfirm
                                        title={`Delete item`}
                                        description={`Are you sure to delete this item?`}
                                        onConfirm={() => triggerDeletecharacterImage(record)}
                                        okText="OK"
                                        cancelText="Cancel"
                                    >
                                        <Tooltip title="Delete">
                                            <span role="button" className='d-inline-block me-2'>
                                                <Icon name="trash-2" color="red" size={16}/>
                                            </span>
                                        </Tooltip>
                                    </Popconfirm>
                                </>
                            )
                        }
                    </>
                );
            },
        },
    ];

    useEffect(() => {
        if (!characterDetail) {
            return;
        }
        search();
    }, [pageIndex]);

    useEffect(() => {
        if (!characterDetail) {
            return;
        }
        if (pageIndex === 1) {
            search();
            return;
        }
        setPageIndex(1);
    }, [pageSize]);

    const search = async () => {
        setSearchLoading(true);
        const searchObj: any = {
            pageIndex: pageIndex - 1,
            pageSize,
        };
        try {
            const response = await getCharacterImageGenProfiles(characterDetail.id, searchObj);
            if (response.status === 200) {
                const data: any[] = [];
                response.data.data.forEach((item: any, index: number) => {
                    data.push({
                        ...item,
                        noNumber: (pageIndex - 1) * pageSize + index + 1,
                    });
                });
                setCharacterImageGenProfiles(data);
                setTotalRecord(response.data.totalRecord);
            }
        } catch (err) {
            console.error(err);
            api.error({
                message: `Error notification`,
                description: <span className="text-danger">{err as string || 'There\'re some errors occured!'}</span>,
                placement: 'topRight'
            });
        }
        setSearchLoading(false);
    }

    const changeImageVisibility = async (characterImage: CharacterImageGenProfileModel, currentStatus: string) => {
        const response = await updateCharacterImageGenProfile(characterImage.characterId, characterImage.id, {status: currentStatus == "inactive" ? "active" : "inactive"});
        if (response.status === 200) {
            api.success({
                message: `Successfull notification`,
                description: (currentStatus === "activated" ? 'Deactivate' : 'Activate') + ' item successfully!',
                placement: 'topRight'
            });
            search();
        }
    }


    const triggerDeletecharacterImage = async (characterImage: CharacterImageGenProfileModel) => {
        const response = await deleteCharacterImageGenProfile( characterImage.characterId, characterImage.id);
        if (response.status === 200) {
            api.success({
                message: `Successfull notification`,
                description: 'Delete item successfully!',
                placement: 'topRight'
            });
            search();
        }
    }

    return (
        <Drawer
            title={"character image and appearance"}
            className='character-drawer'
            width={950}
            onClose={() => {
                setdDrawerVisibility(false)
            }}
            open={drawerVisibility}
            closeIcon={false}
        >
            {contextHolder}
            <Row className='mt-5 mb-1'>
                <Col>
                    <Button variant="success" className="mb-1 py-1 me-1" onClick={() => {
                        search();
                    }}>
                        <i className="mdi mdi-refresh me-1"></i> Refresh
                    </Button>
                </Col>
                <Col>
                    <AntButton type="primary"  className="mb-1 py-1 me-1" onClick={() => {
                        aiGen();
                    }} loading={loadingBtn}>
                        <i className="mdi mdi-creation"></i> Gen Image And Appearance
                    </AntButton>
                </Col>
            </Row>
            <Row>
                <Col className='w-100'>
                    <Table
                        loading={searchLoading}
                        rowKey={"noNumber"}
                        className="table table-hover m-0 table-centered dt-responsive nowrap w-100"
                        dataSource={characterImageGenProfiles}
                        columns={columns}
                        pagination={false}
                    />

                    {characterImageGenProfiles?.length !== 0 && (
                        <CustomPagination
                            pageIndex={pageIndex}
                            pageSize={pageSize}
                            totalItem={totalRecord}
                            setPageSize={setPageSize}
                            setPageIndex={setPageIndex}
                        />
                    )}
                </Col>
            </Row>
        </Drawer>
    )

}

export default CharacterImageGenProfileDrawer;
